export const IDEATION = {
  newIdeation: 'New ideation',
  tableName: 'Ideation name',
  tableStatus: 'Status',
  tableCreated: 'Created',
  tableCommentsFeedback: 'Comments & feedback',
  tableLastAccess: 'Last access',
  topIdeas: 'Top ideas',
  engagement: 'Engagement',
  participant: 'Participant',
  participants: 'Participants',
  comment: 'Comment',
  comments: 'Comments',
  idea: 'Idea',
  ideas: 'Ideas',
  promotedIdeas: 'Promoted ideas',
  publish: 'Publish',
  draft: 'Draft',
  ideation: 'Ideation',
  seeLive: 'See Live',
  ideationStartSubTitle: 'Your responses will remain anonymous.',
  addIdea: 'Add Idea',
  voteFavoriteTitle: 'Vote for your favorite ideas!',
  topVoted: 'Top voted',
  mostRecent: 'Most recent',
  yourVotes: 'Your votes',
  noIdeasAddedYet: 'No ideas added yet!',
  voteAvailable: 'Votes available',
  votesAvailable: 'Votes available',
  submitYourVotes: 'Submit your votes',
  poweredBy: 'Powered by',
  notAvailable: 'Preview is not available yet. Please',
  andRefreshPage: 'and refresh the page',
  thankYou: 'Thank you!',
  submittedSuccessfully: 'Your votes have been submitted successfully!',
  title: 'Title',
  introduction: 'Introduction',
  preview: 'Preview',
  logoPlaceholder: 'Upload your logo',
  dragPlaceholder: 'Drag your files here or ',
  browse: 'Browse',
  crowdsourceRequest: 'Crowdsource request',
  crDescriptionText: 'Ask your colleagues for ideas and suggestions',
  crQuestion: 'How can we improve this initiative?',
  piDescriptionText:
    'Get the conversation started with your own suggested ideas',
  commentsDescriptionText:
    'Enable comments to allow users to reply to ideas. All interactions will remain anonymous.',
  votesText: 'Votes per participant',
  ideationTitlePlaceholder: 'Enter a title for your ideation',
  ideationDescPlaceholder: 'Enter an introduction for your ideation',
  voteForYourFavoriteIdeas: 'Vote for your favorite ideas',
  switchMessage: 'Please enable at least one of the switches',
  setup: 'Setup',
  results: 'Results',
  writeHereYourIdea: 'Write here your idea',
  'addYourComment...': 'Add your comment...',
  send: 'Send',
  insights: 'Insights',
  showTrends: 'Show Trends',
  summary: 'Summary',
  trendingTopics: 'Trending Topics',
  actionableInsights: 'Actionable insights',
  sentimentAnalysis: 'Sentiment Analysis',
  questionPlaceholder: 'Enter a question here',
  failedToLoadIdeations: 'Failed to load ideations',
} as const
